import { XTinyMCE } from '@adornis/writer/x-tinymce.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement logistik-component-tinymce
 */
@customElement('logistik-component-tinymce')
export class LogistikComponentTinymce extends XTinyMCE {
  @property() placeholder?: string;

  override editorOptions = {
    toolbar: 'undo redo | bold italic underline strikethrough |  numlist bullist',
    language: 'de',
    placeholder: this.getAttribute('placeholder') || '',
  };
}
